<template>
  <div class="date-picker d-flex align-center">
    <v-menu
        v-model="isShow"
        transition="scale-transition"
        :close-on-content-click="false"
        offset-y min-width="0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-model="month"
            v-bind="attrs" v-on="on"
            append-icon="calendar_today"
            outlined dense readonly hide-details
            background-color="white"
            @click:append="isShow = !isShow"
            :disabled="disabled"
        />
      </template>
      <v-date-picker
          v-model="month" locale="ko-kr"
          type="month"
          @input="closeClick"
          :show-current="false"
          :day-format="removeBackWord"
          :disabled="disabled"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["selectMonth", "disabled"],
  data() {
    return {
      isShow: false,
      month: ""
    }
  },
  created() {
    this.month = this.selectMonth;
  },
  methods: {
    validation() {
      this.$emit("updateMonth", this.month);
    },
    removeBackWord(m) {
      return new Date(m).getMonth() + 1;
    },
    closeClick() {
      this.validation();
      this.isShow = false;
    }
  }
}
</script>

<style>
.date-picker {
  flex: 1 1 auto;
}
</style>